/* ============ FAQ 折叠 ============ */
$('.faq_item').each(function () {
    var $item = $(this);
    var $question = $item.find('.faq_question');

    if (!$question.length) {
        return;
    }

    $question.on('click', function () {
        var isOpen = $item.hasClass('active');

        /* 手风琴模式：关闭其它项 */
        $('.faq_item').removeClass('active');

        if (!isOpen) {
            $item.addClass('active');
        }
    });
});
